var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-16 pb-10 pt-4"},[_c('div',{staticStyle:{"height":"70vh"}},[_c('iframe',{staticClass:"w-full h-full",attrs:{"id":"blob"}})])])
}]

export { render, staticRenderFns }